import VueRouter from "vue-router";
import Vue from "vue";
import roles from './ressources/roles'
Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        redirect: "/app/lots",
    },
    {
        path: "/login",
        name: "Login",
        component: () =>
            import(/* webpackChunkName: "login" */ "./views/Login.vue"),
    },
    {
        path: "/change-password",
        name: "ChangePassword",
        component: () =>
            import(/* webpackChunkName: "change_password" */ "./views/ChangePassword.vue"),
    },
    {
        path: "/app",
        component: () =>
            import(/* webpackChunkName: "main" */ "./views/Main.vue"),
        meta: {
            auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER, roles.BO_COASTAL_USER],
        },
        children: [
            {
                path: "lots",
                name: "AllLots",
                component: () =>
                    import(
                        /* webpackChunkName: "lots_all" */ "./views/lots/All.vue"
                    ),
                meta: {
                    keepAlive: true,
                    auth: {
                        roles: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                        forbiddenRedirect: "/app/direct-outgoings"
                    },
                },
            },
            {
                path: "logistical-lots",
                name: "AllLogisticalLots",
                component: () =>
                    import(
                        /* webpackChunkName: "logistical_lots_all" */ "./views/direct_outgoings/All.vue"
                        ),
                meta: {
                    auth: {
                        roles: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                    },
                },
            },
            {
                path: "lots/:lotId/details",
                name: "LotDetails",
                component: () =>
                    import(
                        /* webpackChunkName: "lots_detail" */ "./views/lots/Detail.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "logistical-lots/:lotId/details",
                name: "LogisticalLotDetails",
                component: () =>
                    import(
                        /* webpackChunkName: "logistical_lots_detail" */ "./views/direct_outgoings/Detail.vue"
                        ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "direct-outgoings",
                name: "DirectOutgoings",
                component: () =>
                    import(
                        /* webpackChunkName: "direct_outgoings" */ "./views/direct_outgoings/DirectOutgoings.vue"
                    ),
                children: [
                    {
                        path: ":companyId",
                        name: "CompanyDirectOutgoings",
                        components: {
                            view: require("./views/direct_outgoings/CompanyDirectOutgoings").default
                        }
                    }
                ],
            },
            {
                path: "transports",
                name: "AllTransports",
                component: () =>
                    import(
                        /* webpackChunkName: "transports_all" */ "./views/transports/All.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "transports/add",
                name: "TransportAdd",
                component: () =>
                    import(
                        /* webpackChunkName: "transports_add" */ "./views/transports/Add.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "transports/:id/details",
                name: "TransportDetails",
                component: () =>
                    import(
                        /* webpackChunkName: "transports" */ "./views/transports/Detail.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "instructions",
                name: "AllInstructions",
                component: () =>
                    import(
                        /* webpackChunkName: "instructions_all" */ "./views/instructions/All.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "delivery_reports",
                name: "AllDeliveryReports",
                component: () =>
                    import(
                        /* webpackChunkName: "delivery_reports_all" */ "./views/delivery_reports/All.vue"
                        ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                }
            },
            {
                path: "archives",
                name: "AllArchives",
                component: () =>
                    import(
                        /* webpackChunkName: "archives_all" */ "./views/archives/All.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "archives/:lotId/details",
                name: "ArchiveDetails",
                component: () =>
                    import(
                        /* webpackChunkName: "archives_detail" */ "./views/archives/Detail.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "repositories/companies",
                name: "AllCompanies",
                component: () =>
                    import(
                        /* webpackChunkName: "companies_all" */ "./views/repositories/companies/All.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "repositories/companies/:companyId/details",
                name: "CompanyDetails",
                component: () =>
                    import(
                        /* webpackChunkName: "companies_detail" */ "./views/repositories/companies/Detail.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "repositories/company-groups",
                name: "AllCompanyGroups",
                component: () =>
                    import(
                        /* webpackChunkName: "company_groups_all" */ "./views/repositories/company_groups/All.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "repositories/delivery-points",
                name: "AllDeliveryPoints",
                component: () =>
                    import(
                        /* webpackChunkName: "delivery_points_all" */ "./views/repositories/delivery_points/All.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "repositories/transport-templates",
                name: "AllTransportTemplates",
                component: () =>
                    import(
                        /* webpackChunkName: "transport_templates_all" */ "./views/repositories/transport_templates/All.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "repositories/transport-templates/edit/:transportModelId",
                name: "TransportTemplateEdit",
                component: () =>
                    import(
                        /* webpackChunkName: "transport_templates_edit" */ "./views/repositories/transport_templates/Edit.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "repositories/transport-templates/add",
                name: "TransportTemplateAdd",
                component: () =>
                    import(
                        /* webpackChunkName: "transport_templates_add" */ "./views/repositories/transport_templates/Add.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "repositories/species-sizes",
                name: "AllSpeciesSizes",
                component: () =>
                    import(
                        /* webpackChunkName: "species_sizes_all" */ "./views/repositories/species_sizes/All.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "repositories/freshness",
                name: "AllFreshness",
                component: () =>
                    import(
                        /* webpackChunkName: "freshness_all" */ "./views/repositories/freshness/All.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "repositories/containers",
                name: "AllContainers",
                component: () =>
                    import(
                        /* webpackChunkName: "containers_all" */ "./views/repositories/containers/All.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "repositories/fishing_modes",
                name: "AllFishingModes",
                component: () =>
                    import(
                        /* webpackChunkName: "fishing_modes_all" */ "./views/repositories/fishing_modes/All.vue"
                    ),
                meta: {
                    auth: [roles.ADMIN, roles.BO_CONSULTATION_USER, roles.BO_LOGISTIC_USER],
                },
            },
            {
                path: "users",
                name: "AllUsers",
                component: () =>
                    import(
                        /* webpackChunkName: "users_all" */ "./views/users/All.vue"
                    ),
                meta:{
                    auth: [roles.ADMIN]
                }
            },
            {
                path: "parameters",
                name: "AllParameters",
                component: () =>
                    import(
                        /* webpackChunkName: "parameters_all" */ "./views/parameters/All.vue"
                        ),
                meta:{
                    auth: [roles.ADMIN]
                }
            },
        ],
    },
    {
        path: "/403",
        name: "forbidden",
        component: require("./views/errors/403").default,
        meta: {
            layout: "single",
        },
    }, {
        path: "/404",
        name: "not_found",
        component: require("./views/errors/404").default,
    },
];

export const router = new VueRouter({
    routes,
    mode: "history",
});

Vue.router = router;
